import { z } from 'zod';
import { FetchClient } from '@foundatiofx/fetchclient';

export const clientPortalSchema = z.object({
    id: z.number(),
    name: z.string().default(''),
    portalUrl: z.string().default(''),
    isLoginEnabled: z.boolean().default(false),
    isRegistrationEnabled: z.boolean().default(false),
    isExternalLoginEnabled: z.boolean().default(false),
    isExternalPortal: z.boolean().default(false),
    logoUrl: z.string().default(''),
    favIconUrl: z.string().default(''),
    themeData: z.record(z.string(), z.any()).default({}).nullable(),
    privacyPolicyHtml: z.string().nullable().default(null),
    termsHtml: z.string().nullable().default(null),
    termsUpdatedUtc: z.coerce.date().optional(),
    genesysDeploymentId: z.string().max(50, { message: 'Deployment ID must be 50 characters or less' }).default('')
});

export type ClientPortal = z.infer<typeof clientPortalSchema>;

export class ClientSettingsApi {
    private fetch: FetchClient;
    private route = 'clients';

    constructor(fetch?: FetchClient) {
        this.fetch = fetch ?? new FetchClient();
    }

    async getSettings() {
        return await this.fetch.getJSON<ClientPortal>(`${this.route}/settings`);
    }

    async getPortal(clientId: number) {
        return await this.fetch.getJSON<ClientPortal>(`${this.route}/${clientId}/portal`);
    }

    async updatePortal(clientId: number, data: Partial<ClientPortal>) {
        return await this.fetch.putJSON<ClientPortal>(`${this.route}/${clientId}/portal`, data);
    }
}
